import { render, staticRenderFns } from "./ItemsTree.vue?vue&type=template&id=5f8b056b&scoped=true&"
import script from "./ItemsTree.vue?vue&type=script&lang=js&"
export * from "./ItemsTree.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTree.vue?vue&type=style&index=0&id=5f8b056b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b056b",
  null
  
)

export default component.exports